import { useToast } from "contexts/ToastContext";
import ScheduleTitlePresentationModal from "pages/conductLegalResearch/fragments/scheduleTitlePresentationModal";
import DistributeToZone from "pages/legalTraningProvision/fragments/distributeToZone";
import { useState } from "react";
import { updateLegalAwareness } from "services/legalAwarenessService";
import { updateLegislativeDrafting } from "services/legislativeService";
import ShowUI, { CanShow, LEGISLATIVE_DRAFTING_UI_RULES } from "utils/authRules";
import { LoadingIcon } from "utils/constant";
import { LAW_IMPLEMENTATION_REQUEST_STATUS, LEGAL_ADVISORY_REQUEST_STATUS, LEGAL_AWAERENESS_REQUEST_STATUS, LEGISLATIVE_DRAFTING_REQUEST_STATUS } from "utils/constantValues";
import UploadDraftLaw from "./uploadDraftLaw";
import UploadResearchData from "./uploadRequestForAdditionalInfo";
import { useTranslation } from "react-i18next";

export default function ProsecutorRemark({ setFormState, formState }: { setFormState: any, formState: any }) {
    const { t } = useTranslation();
    const [loading, setLoading] = useState(false);
    const { showToast } = useToast();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isTargetModalOpen, setIsTargetModalOpen] = useState(false);
    const [isFeedbackModalOpen, setIsFeedbackModalOpen] = useState(false);
    const [isRequestModalOpen, setIsRequestModalOpen] = useState(false);

    const handleCloseModal = () => {
        setIsModalOpen(false);
    }
    const handleFeedbackCloseModal = () => {
        setIsFeedbackModalOpen(false);
    }
    const handleTargetCloseModal = () => {
        setIsTargetModalOpen(false);
    }
    const handleRequestCloseModal = () => {
        setIsRequestModalOpen(false);
    }

    const handleReject = () => {
    }

    const handleUploadProposalClick = () => {
    }

    const handleForward = async (froward_status: string) => {
        setLoading(true);
        const data = new FormData();

        data.append(
            "forward_status",
            froward_status
        );

        try {
            const response = await updateLegalAwareness(formState.id, data);

            setFormState((prev: any) => ({ ...prev, ...response }));
            showToast(t("LegalAwarenessForwardedSuccess") || "Legal Awareness Forwarded successfully!", "success");
        } catch (error) {
            console.error("Error submitting request:", error);
            showToast(t("FailedToUpdateLegalAwarenessRequest") || "Failed to update Legal Awareness request.", "error");
        } finally {
            setLoading(false);
        }
    };
    
    return (
        <>
            <div className="mt-4 flex flex-col sm:flex-row sm:items-center gap-3">
                <ShowUI
                    ui_key={LEGISLATIVE_DRAFTING_UI_RULES.schedule_awareness.value}
                    currentStatus={formState.current_approval_status}
                    forwardStatus={formState.forward_status}
                >
                    <button
                        type="button"
                        onClick={() => !loading && setIsTargetModalOpen(true)}
                        disabled={loading}
                        className="inline-flex flex-1 w-full items-center justify-center gap-2 px-5 py-2.5 rounded-lg border border-[#0A1D39] text-[#0A1D39] text-sm font-semibold hover:bg-[#0A1D39] hover:text-white focus:outline-none focus:ring-2 focus:ring-[#0A1D39]/30 transition-colors disabled:opacity-50"
                    >
                        {loading ? (
                            <>{LoadingIcon} {t("Submitting") || "Submitting..."}</>
                        ) : (
                            <>
                                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                                </svg>
                                {t("Schedule") || "Schedule"}
                            </>
                        )}
                    </button>
                </ShowUI>
                <ShowUI
                    ui_key={LEGISLATIVE_DRAFTING_UI_RULES.distribute_to_zone.value}
                    currentStatus={formState.current_approval_status}
                    forwardStatus={formState.forward_status}
                >
                    <button
                        type="button"
                        onClick={() => !loading && setIsModalOpen(true)}
                        disabled={loading}
                        className="inline-flex flex-1 w-full items-center justify-center gap-2 px-5 py-2.5 rounded-lg bg-[#0A1D39] text-white text-sm font-semibold shadow-sm hover:bg-[#13294d] focus:outline-none focus:ring-2 focus:ring-[#0A1D39]/40 transition-colors disabled:opacity-50"
                    >
                        {loading ? (
                            <>{LoadingIcon} {t("Submitting") || "Submitting..."}</>
                        ) : (
                            <>
                                <svg className="w-4 h-4" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={2}>
                                    <path strokeLinecap="round" strokeLinejoin="round" d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
                                </svg>
                                {t("DistributeToZone") || "Distribute to Zone"}
                            </>
                        )}
                    </button>
                </ShowUI>
            </div>
            <ScheduleTitlePresentationModal
                data={formState}
                setLegalResearch={setFormState}
                isOpen={isTargetModalOpen}
                onClose={handleTargetCloseModal}
                type="awareness"
            />
            {isModalOpen &&
                <DistributeToZone
                    setFormState={setFormState}
                    formState={formState}
                    setEdit={setIsModalOpen}
                    type="awareness"
                />
            }
        </>
    );
}